import { render, staticRenderFns } from "./activityCard.vue?vue&type=template&id=27d03611&scoped=true"
import script from "./activityCard.vue?vue&type=script&lang=js"
export * from "./activityCard.vue?vue&type=script&lang=js"
import style0 from "./activityCard.vue?vue&type=style&index=0&id=27d03611&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d03611",
  null
  
)

export default component.exports